import CONSTANTS from '../../util/constants';

const initState = {
    isLoading: false,
    id: "",
    doorName: "",
    getDoorData: [],
    addDoorData: [],
    editDoorData: [],
    getDoorsById: [],
    getDoorForMove: [],
    getDoorLogs: []
}

const DoorReducer = (state = initState, { type, payload }) => {


    switch (type) {
        case CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.DOORS_ID_UPDATE:
            return {
                ...state,
                id: payload.value
            }

        case CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.DOORS_NAME_UPDATE:
            return {
                ...state,
                doorName: payload.value
            }

        case CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.ADD_DOORS_API_SUCCESS:

            return {
                ...state,
                addDoorData: payload.value
            }

        case CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_API_SUCCESS:

            return {
                ...state,
                getDoorData: payload.value
            }

        case CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.EDIT_DOORS_API_SUCCESS:

            return {
                ...state,
                editDoorData: payload.value
            }

        case CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORSBYID_MANAGEMENT_API_SUCCESS:

            return {
                ...state,
                getDoorsById: payload.value
            }
        case CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_FOR_MOVE_MANAGEMENT_API_SUCCESS:

            return {
                ...state,
                getDoorForMove: payload.value
            }

        case CONSTANTS.CONSTANTS_DOORS_MANAGEMENT.GET_DOORS_LOG_MANAGEMENT_API_SUCCESS:
            {
                
                return {
                    ...state,
                    getDoorLogs: payload.value
                }
            }
        default:
            return state
    }
}

export default DoorReducer;
